import pick from 'lodash.pick';
const AUTO_STRATEGY_GROUP_FIELDS = [
  'id', 'enabled', 'is_logging_enabled', 'name', 'channel_id', 'placement_ids', 'labels', 'autostrategy_id',
  'autostrategy_arguments_values'
];

export default function autoStrategyGroupSerializer (group) {
  return pick(group, AUTO_STRATEGY_GROUP_FIELDS);
}
